import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import Skeleton from '@ynap/skeleton'

const bem = new BEMHelper('OrderStatusSkeleton')

const OrderStatusSkeleton: React.FC = () => {
    return (
        <div className={bem(null)}>
            <Skeleton className={bem('top')} />
            <Skeleton />
            <Skeleton className={bem('fakeButton')} />
        </div>
    )
}

export default OrderStatusSkeleton
